<template>
  <footer class="footer">
    <div class="footer__container">
      <CheckoutFooterMain v-if="isCheckoutPage" />
      <FooterMain v-else />
      <FooterDevelopers :messages="messages" />
    </div>
    <AcceptCookies />
    <DefGoToTop />
    <FooterMiniBanner
      v-if="footerMiniBannerStore.doShowMiniBanner"
      :result="footerMiniBannerStore"
    />
  </footer>
</template>

<script lang="ts" setup>
import FooterMain from '@components/Footer/FooterMain.vue';
import FooterDevelopers from '@components/Footer/FooterDevelopers.vue';
import AcceptCookies from '@components/Modals/AcceptCookies/AcceptCookies.vue';
import DefGoToTop from '@components/Def/DefGoToTop/DefGoToTop.vue';
import useModal from '@use/useModal/useModal';
import ChangeSiteVersion from '@components/Modals/ChangeSiteVersion/ChangeSiteVersion.vue';
import { listenerFirstInteraction } from '@/utils/helpers';
import CheckoutFooterMain from '@components/Checkout/CheckoutFooter/CheckoutFooterMain.vue';
import { useResultsStore } from '@/storePinia/stores/results';
import { useBasketStore } from '@/storePinia/stores/basket';
import { useFooterMiniBannerStore } from '@/storePinia/stores/footerMiniBanner';
import { computed, onMounted, onBeforeMount, defineAsyncComponent } from 'vue';
import { useCitiesStore } from '@/storePinia/stores/cities';
import { getCookie } from '@/utils/cookies';

const FooterMiniBanner = defineAsyncComponent(
  () => import('@components/Footer/FooterMiniBanner.vue')
);

const modal = useModal();
const changeSiteVersion = getCookie('WebsiteVersionModalShowed');
const resultsStore = useResultsStore();
const basketStore = useBasketStore();
const footerMiniBannerStore = useFooterMiniBannerStore();
const citiesStore = useCitiesStore();

const messages = computed(() => resultsStore.messages);
const isCheckoutPage = computed(() => window.location.pathname.includes('/personal/order/make/'));

const removeIPostDataFromStorage = () => {
  basketStore.getBackBasketItems();
};

const changeSiteVersionModal = () => {
  if (!changeSiteVersion) {
    listenerFirstInteraction(() => {
      modal.show(ChangeSiteVersion, {}, { width: '440px', backgroundClose: false });
    });
  }
};

const initStores = async () => {
  await citiesStore.getUserCityFromNP();
};

onBeforeMount(async () => {
  if (!window.location.pathname.includes('/personal/order/make/')) {
    await initStores();
  }
});

onMounted(() => {
  // page speed
  if ('requestIdleCallback' in window) {
    requestIdleCallback(
      () => {
        basketStore.setClubCard();
        removeIPostDataFromStorage();

        footerMiniBannerStore.refreshMiniBanner(window.location.pathname);
        changeSiteVersionModal();
      },
      { timeout: 2000 }
    );
  } else {
    setTimeout(() => {
      basketStore.setClubCard();
      removeIPostDataFromStorage();

      footerMiniBannerStore.refreshMiniBanner(window.location.pathname);
      changeSiteVersionModal();
    }, 1500);
  }
});
</script>

<style lang="scss" scoped>
.footer {
  background-color: var(--background-black);
  color: #fff;
  &__container {
    @extend %container;
  }
}
</style>
